<div *ngIf="loadingRequest">
    <p>Please wait while we load the new payment method request</p>
</div>
  
<form (submit)="handleForm($event)"
        [formGroup]="form"
        [hidden]="loadingRequest">

    <div fxLayout="row" style="margin-bottom: 10px">
        <div fxFlex="30">Cardholder Name</div>
        <div fxFlex="70">
            <mat-form-field class="mat-field-width">
                <input matInput
                    type="text"
                    formControlName="cardHolderName"
                    [ngClass]="{'is-invalid': submitted && !form.controls['cardHolderName'].valid}"
                    placeholder="Cardholder name"
                    name="cardHolderName">
            </mat-form-field>
        </div>
    </div>
    
    <div fxLayout="row" style="margin-bottom: 10px">
        <div fxFlex="30">Card Number</div>
        <div fxFlex="70">
            <div #cardNumber></div>
        </div>
    </div>
    
    <div fxLayout="row" style="margin-bottom: 10px">
        <div fxFlex="30">CVC</div>
        <div fxFlex="70">
            <div #cardCvc></div>
        </div>
    </div>
    
    <div fxLayout="row" style="margin-bottom: 40px">
        <div fxFlex="30">Expiry date</div>
        <div fxFlex="70">
            <div #cardExpiry></div>
        </div>
    </div>
  
    <button mat-raised-button
            color="primary"
            [disabled]="loading">
        <mat-icon>credit_card</mat-icon>
        Save Card
    </button>
  
    <div class="alert alert-danger" *ngIf="cardErrors" style="margin-top: 10px">
        <p>{{ cardErrors }}</p>
    </div>
  
  
</form>
  